"use client";

interface DownloadFileProps {
	downloadUrl: string;
	fileName?: string;
}

export const downloadFile = ({
	downloadUrl,
	fileName,
}: DownloadFileProps): void => {
	const anchor = document.createElement("a");
	anchor.href = downloadUrl;
	if (fileName) {
		anchor.download = fileName;
	}
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
};
